import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// LIBS
import API from "../../api";
import Model from "../../models/users";
import validateForm from "../../lib/helpers/validateForm";
import { generatePassword } from "../../lib/helpers/strings";
import { getDateFormat, getDateFromDatepicker } from "../../lib/helpers/dates";

// UI
import {
  Alerts,
  Header,
  HeaderPage,
  Box,
  Row,
  Col,
  Input,
  Button,
  Dropdown
} from "../../ui";

class UserEditPage extends Component {
  state = {
    loading: true,
    titleHeader: `${
      this.props.match.params.id ? "Изменение" : "Создание"
    } пользователя`,
    user: {},
    form: {
      f: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.f
      },
      i: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.i
      },
      o: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.o
      },
      email: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.email
      },
      iin: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.iin
      },
      docs: {
        value: "",
        isEdited: false,
        isNumber: false,
        isError: false,
        errors: [],
        validate: Model.docs
      },
      docs_number: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.docs_number
      },
      docs_give_from: {
        value: "",
        isEdited: false,
        isNumber: false,
        isError: false,
        errors: [],
        validate: Model.docs_give_from
      },
      docs_give_date: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.docs_give_date
      },
      tel: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.tel
      },
      address: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.address
      },
      username: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.username
      },
      password: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.password
      },
      role_id: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.roleId
      },
      filial_id: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.filialId
      },
      power_of_attorney_number_document: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.power_of_attorney_number_document
      },
      power_of_attorney_date_give: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.power_of_attorney_date_give
      }
    },
    saveDisabled: false,
    docs: {
      list: [
        {
          id: "ud",
          title: "Удостоверение личности",
          onSelect: true,
          select: true
        },
        {
          id: "passport",
          title: "Паспорт",
          onSelect: true,
          select: true
        }
      ]
    },
    roleId: {
      list: []
    },
    filialId: {
      list: []
    }
  };

  async componentDidMount() {
    const userId = this.props.match.params.id;

    // Edit or Create
    if (userId) {
      const user = await API.users.getOne(userId, { full: true });

      if (user && user._id) {
        const { form } = this.state;

        // Заполняем форму
        for (let key in form) {
          if (form[key].isNumber) {
            form[key].value = String(user[key] || "") || "";
          } else if (form[key].isDate) {
            let resultDate = getDateFromDatepicker(user[key]);
            form[key].value = user[key]
              ? resultDate.isCorrect
                ? getDateFormat(resultDate.date)
                : user[key]
              : "";
          } else {
            if (key === "role_id" || key === "filial_id") {
              if (user[key] && user[key]._id) {
                form[key].value = user[key]._id || "";
              } else {
                form[key].value = "select";
              }
              // TODO: Удалить эту логику с паролем
            } else if (key === "password") {
              form[key].validate = {};
            } else if (key === "power_of_attorney_number_document") {
              form[key].value =
                (user.power_of_attorney &&
                  user.power_of_attorney.number_document) ||
                "";
            } else if (key === "power_of_attorney_date_give") {
              form[key].value =
                (user.power_of_attorney && user.power_of_attorney.date_give) ||
                "";
            } else {
              form[key].value = user[key] || "";
            }
          }
        }

        this.setState({ user, form });
      }
    }

    // Get roles
    const roles = await API.roles.getList({});
    const rolesList = (roles || []).map(item => {
      return {
        id: item._id,
        title: item.name,
        onSelect: true,
        select: true
      };
    });

    // Get filials
    const filials = await API.filials.getList({ all: true });
    const filialsList = [
      {
        id: "select",
        title: "Филиал не выбран"
      }
    ];
    (filials || []).forEach((item, i) => {
      if (i === 0) {
        filialsList.push({
          type: "hr"
        });
      }

      filialsList.push({
        id: item._id,
        title: item.name,
        onSelect: true,
        select: true
      });
    });

    this.setState({
      loading: false,
      roleId: {
        list: rolesList
      },
      filialId: {
        list: filialsList
      }
    });
  }

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value || "") || "";
      }

      if (name === "password") {
        form[name].validate = Model.password;
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleDatepicker = (name, value) => {
    this.setState(prevState => {
      return {
        form: {
          ...prevState.form,
          [name]: {
            ...prevState.form[name],
            value,
            isEdited: true,
            isError: false,
            errors: []
          }
        }
      };
    });
  };

  handleSelectDropdown(item, name) {
    if (item && name) {
      let value = item.id;

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  }

  handleGeneratePasswordUserCreate = e => {
    e.preventDefault();

    const form = this.state.form;

    // Генерируем пароль
    form.password.errors = [];
    form.password.validate = Model.password;
    form.password.isEdited = true;
    form.password.isError = false;
    form.password.value = generatePassword();

    this.setState({ form });
  };

  handleFormSubmit = async e => {
    e.preventDefault();

    const result = validateForm(this.state.form);

    this.setState({
      form: result.form
    });

    // Success
    if (result.valid) {
      // Отключаем кнопку
      this.setState({
        saveDisabled: true,
        loading: true
      });

      const { form } = this.state;
      const userId = this.props.match.params.id;
      const optionsRequest = {};

      // Если изменение, только изменённые поля
      if (userId) {
        for (let nameItem in form) {
          if (form[nameItem].isEdited) {
            optionsRequest[nameItem] = form[nameItem].value;
          }
        }
      } else {
        // Иначе все поля
        for (let nameItem in form) {
          optionsRequest[nameItem] = form[nameItem].value;
        }
      }

      // Есть изменения?
      if (Object.keys(optionsRequest).length) {
        // Edit or Create
        if (userId) {
          // Изменение текущего
          const resultUpdated = await API.users.editOne(userId, {
            ...optionsRequest
          });

          if (resultUpdated) {
            Alerts.success("Информация о пользователе сохранена");

            // Включаем кнопку, данные сохранились
            this.setState({
              saveDisabled: false
            });

            this.props.history.goBack();
          } else {
            Alerts.error("Информация о пользователе не сохранена");

            // Включаем кнопку, данные не сохранились
            this.setState({
              saveDisabled: false
            });
          }
        } else {
          // Создание нового
          const resultCreated = await API.users.createOne({
            ...optionsRequest
          });

          if (resultCreated) {
            Alerts.success("Создан новый пользователь");

            // Включаем кнопку, данные сохранились
            this.setState({
              saveDisabled: false
            });

            this.props.history.goBack();
          } else {
            Alerts.error("Пользователь не создан");

            // Включаем кнопку, данные не сохранились
            this.setState({
              saveDisabled: false
            });
          }
        }
      } else {
        Alerts.alert("В информации о пользователе нет изменений");

        // Включаем кнопку, данные не сохранились
        this.setState({
          saveDisabled: false
        });

        this.props.history.goBack();
      }
    } else {
      Alerts.error("Заполните поля правильно");
      console.error(result);
    }
  };

  render() {
    const { user } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage
          title={this.state.titleHeader}
          back={this.props.history.goBack}
        />

        <Box>
          {user.username ? (
            <Header size={2} margin="no-top">
              {user.username}
            </Header>
          ) : null}

          <Row>
            <Col padding="no-top-right-left">
              <form className="form" onSubmit={this.handleFormSubmit}>
                <Header size={5} margin="no-top">
                  Главное
                </Header>

                <Row>
                  <Col padding="no-top-left">
                    <Input
                      label="Фамилия:"
                      name="f"
                      value={this.state.form.f.value}
                      errors={this.state.form.f.errors}
                      handleChange={this.handleInput}
                    />
                  </Col>
                  <Col padding="no-top-left">
                    <Input
                      label="Имя:"
                      name="i"
                      value={this.state.form.i.value}
                      errors={this.state.form.i.errors}
                      handleChange={this.handleInput}
                    />
                  </Col>
                  <Col padding="no-top-left">
                    <Input
                      label="Отчество:"
                      name="o"
                      value={this.state.form.o.value}
                      errors={this.state.form.o.errors}
                      handleChange={this.handleInput}
                    />
                  </Col>

                  {/* <Col padding="no-top-left"> */}
                  {/* <Input
                      label="Email:"
                      name="email"
                      value={this.state.form.email.value}
                      errors={this.state.form.email.errors}
                      handleChange={this.handleInput}
                    /> */}
                  {/* </Col> */}
                </Row>
                <Row>
                  <Col padding="no-top-left">
                    <Input
                      label="Телефон:"
                      name="tel"
                      value={this.state.form.tel.value}
                      errors={this.state.form.tel.errors}
                      handleChange={this.handleInput}
                    />
                  </Col>
                  <Col padding="no-top-left">
                    <Input
                      label="Адрес:"
                      name="address"
                      value={this.state.form.address.value}
                      errors={this.state.form.address.errors}
                      handleChange={this.handleInput}
                    />
                  </Col>
                </Row>

                <Header size={5} margin="no-top">
                  Назначение
                </Header>
                <Row>
                  <Col padding="no-top-left">
                    <Input
                      label="Имя пользователя:"
                      name="username"
                      value={this.state.form.username.value}
                      errors={this.state.form.username.errors}
                      handleChange={this.handleInput}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col padding="no-top-left">
                    <Input
                      label="Пароль:"
                      name="password"
                      value={this.state.form.password.value}
                      errors={this.state.form.password.errors}
                      handleChange={this.handleInput}
                    />
                  </Col>

                  <Col
                    padding="no-top-left"
                    style={{ alignSelf: "center", marginTop: 14 }}
                  >
                    <Button
                      type="button"
                      theme="primary"
                      block={true}
                      onClick={this.handleGeneratePasswordUserCreate}
                    >
                      Сгенерировать пароль
                    </Button>
                  </Col>
                </Row>

                <Row>
                  <Col padding="no-top-left">
                    <Dropdown
                      label="Роль:"
                      name="role_id"
                      block={true}
                      required={true}
                      type="select"
                      title="Выберите роль"
                      errors={this.state.form.role_id.errors}
                      list={this.state.roleId.list}
                      selectedId={this.state.form.role_id.value}
                      onSelect={item => {
                        this.handleSelectDropdown(item, "role_id");
                      }}
                    />
                  </Col>

                  <Col padding="no-top-left">
                    <Dropdown
                      label="Филиал:"
                      name="filial_id"
                      block={true}
                      required={true}
                      type="select"
                      title="Выберите филиал"
                      errors={this.state.form.filial_id.errors}
                      list={this.state.filialId.list}
                      selectedId={this.state.form.filial_id.value}
                      onSelect={item => {
                        this.handleSelectDropdown(item, "filial_id");
                      }}
                    />
                  </Col>
                </Row>

                <Header size={5} margin="no-top">
                  Доверенность
                </Header>
                <Row>
                  <Col padding="no-top-left">
                    <Input
                      label="Номер:"
                      name="power_of_attorney_number_document"
                      value={
                        this.state.form.power_of_attorney_number_document.value
                      }
                      errors={
                        this.state.form.power_of_attorney_number_document.errors
                      }
                      handleChange={this.handleInput}
                    />
                  </Col>
                  <Col padding="no-top-left">
                    <Input
                      label="Дата выдачи:"
                      name="power_of_attorney_date_give"
                      value={this.state.form.power_of_attorney_date_give.value}
                      errors={
                        this.state.form.power_of_attorney_date_give.errors
                      }
                      handleChange={this.handleInput}
                    />
                  </Col>
                </Row>

                <Header size={5} margin="no-top">
                  Документ
                </Header>
                <Row>
                  <Col padding="no-top-left">
                    <Input
                      label="ИИН:"
                      name="iin"
                      // type="integer"
                      value={this.state.form.iin.value}
                      errors={this.state.form.iin.errors}
                      handleChange={this.handleInput}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col padding="no-top-left">
                    <Dropdown
                      label="Вид документа:"
                      name="docs"
                      block={true}
                      required={true}
                      type="select"
                      title="Выберите тип документа"
                      errors={this.state.form.docs.errors}
                      list={this.state.docs.list}
                      selectedId={this.state.form.docs.value}
                      onSelect={item => {
                        this.handleSelectDropdown(item, "docs");
                      }}
                    />
                  </Col>
                  <Col padding="no-top-left">
                    <Input
                      label="Номер документа:"
                      name="docs_number"
                      // type="integer"
                      value={this.state.form.docs_number.value}
                      errors={this.state.form.docs_number.errors}
                      handleChange={this.handleInput}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col padding="no-top-left">
                    <Input
                      label="Кем выдан:"
                      name="docs_give_from"
                      value={this.state.form.docs_give_from.value}
                      errors={this.state.form.docs_give_from.errors}
                      handleChange={this.handleInput}
                    />
                  </Col>
                  <Col padding="no-top-left">
                    <Input
                      label="Дата выдачи:"
                      name="docs_give_date"
                      type="date"
                      dateTop={true}
                      value={this.state.form.docs_give_date.value}
                      errors={this.state.form.docs_give_date.errors}
                      handleChange={this.handleInput}
                      handleChangeDate={this.handleDatepicker}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col padding="no-top-left-right">
                    <Button
                      type="submit"
                      theme="success"
                      block={true}
                      disabled={this.state.saveDisabled}
                    >
                      Сохранить информацию
                    </Button>
                  </Col>
                </Row>
              </form>
            </Col>
          </Row>
        </Box>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(withAuth(UserEditPage));
